import { CommonModule, DOCUMENT, isPlatformServer } from '@angular/common';
import { Component, inject, Inject, input, PLATFORM_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AnimateModule } from '@pro-connect/shared';

@Component({
  selector: 'app-city-top',
  templateUrl: './city-top.component.html',
  styleUrls: ['./city-top.component.scss'],
  imports: [CommonModule, RouterModule, AnimateModule],
})
export class CityTopComponent {
  public readonly bannerUrl = input.required<string>();
  public readonly cityName = input.required<string>();
  public readonly dates = input.required<string>();
  private readonly _platformId = inject(PLATFORM_ID);

  constructor(
    @Inject(DOCUMENT)
    private readonly _document: Document,
  ) {}

  public onScrollToCity(): void {
    if (isPlatformServer(this._platformId)) {
      return;
    }
    this._document.getElementById('cityContent')?.scrollIntoView({
      behavior: 'smooth',
    });
  }
}
